export const OPEN_SIDEBAR = "OPEN_SIDEBAR";
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR";
export const GET_COURSES = "GET_COURSES";
export const GET_SINGLE_COURSE = "GET_SINGLE_COURSE";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
export const CLEAR_CART = "CLEAR_CART";
export const GET_CART_TOTAL = "GET_CART_TOTAL";